"use strict";
import _ from 'lodash';

export default class ChampEditController
{
	/*@ngInject*/
	constructor($state, $stateParams, $log, $http, ValidationService, Modal, messageService)
	{
		//console.log("ChampEditController " + $stateParams.id);
		if (_.isNil($stateParams.id))
			return $state.go("mychamps");

		this.$http = $http;
		this.$state = $state;
		this.$log = $log;
		this.validation = new ValidationService();
		this.Modal = Modal;
		this.messageService = messageService;
		this.champId = $stateParams.id;

		if (!$stateParams.id) 
			return $state.go("home");
	
		this.data = {};

		this.viewPromise = this.$http.post("/api/backend/champs/" + $stateParams.id)
		.then(response =>
		{
			//for (var attrname in response.data) {
			//	this.data[attrname] = response.data[attrname];
			//}

			this.data = response.data;
			if (_.isNil(this.data.extra))
				this.data.extra = [];
		});
	}

	Modify(form)
	{
		this.msgSuccess = "";
		this.message = "";
		
		if (!this.validation.checkFormValidity(form)) 
		{
			//console.log("ERRORES EN EL FORM");
			//this.message = this.$translate.instant("VALIDATION_ERROR");
			return;
		}

		this.$http.post("/api/backend/champs/update/" + this.champId, this.CollectChampData(this.data))
		.then(response =>
		{
			this.$state.go("mychamps");
		})
		.catch(err =>
		{
			this.$log.warn(err);
			this.message = err.data;
			this.messageService.Error(err.data);
		});
	}
		
	Delete(c)
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/backend/champs/del/" + this.champId)
			.then(response => {
				this.$state.go("mychamps");
			});
		})({
			html: [
				"<strong>{{vm.title}}</strong>",
				"¿Seguro que deseas borrar el campeonato y TODOS los resultados?" // {{'DIALOG_DeleteContent'|translate}}" // TODO: ¿Seguro que deseas borrar el campeonato y TODOS los resultados?
			],
			vm: {title: this.data.title}
		}/*Optional params here*/);
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/champs/champ_edit.controller.js